<template lang="html">
  <div class="bar" :style="barStyle">
    <div v-if="duration != 0" class="chunk" :style="chunkStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'ChunkBar',
  props: ['start', 'end', 'duration', 'width'],
  computed: {
    realDuration() {
      return this.duration
    },
    barStyle() {
      // console.log("width", this.width);
      return {
        // align bar with player timeline
        width: this.width-12*2 + 'px',
      }
    },
    chunkStyle() {
      return {
        margin: '0 ' + 'auto ' + '0 ' + this.size.left + '%',
        width: (this.size.width) + '%'
      }
    },
    size() {
      let left = this.start/this.duration*100;
      let width = (this.duration - this.start)/this.duration*100;

      // if chunk has end
      if (this.end > this.start) {
        width = (this.end-this.start)/this.duration*100
      }

      // make relatively small chunks better visible
      // console.log("(", width, ")");
      if (width < 1) {
        width = 1
      }

      if (left > 99) {
        left = 99
      }

      return {
        left: left,
        width: width
      }
    },
  }
}
</script>

<style lang="css" scoped>
.bar {
  height: 7px;
  margin: 0 auto 1rem;
  border-top: 1px solid rgb(232, 162, 57);
}
.bar div {
  background-color: rgb(232, 162, 57);
}
.bar > .chunk {
  height: 100%;
  border-bottom-right-radius: 7px;
  border-bottom-left-radius:  7px;
}
</style>
